import React, { FC } from 'react'

interface PotionProps {
  className?: string
}

export const Potion: FC<PotionProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill={'none'}
      height={'100'}
      viewBox={'0 0 97 100'}
      width={'97'}
      xmlns={'http://www.w3.org/2000/svg'}
    >
      <g clipPath={'url(#clip0_8650_5163)'}>
        <path
          d={`
            M39.351 58.3431
            L30.6752 53.9516
            L8.36597 85.3191
            L12.394 92.5336
            H82.7299
            L87.0678 85.3191
            L68.4768 58.3431
            L57.3222 56.461
            L39.351 58.3431Z
            `}
          fill={'#00A843'}
          stroke={'#181716'}
          strokeWidth={'1.80221'}
        />
        <path
          d={
            'M28.198 0.3502L31.7003 2.40547e-05C32.1301 -0.0428547 32.5097 0.300175 32.5025 0.736109C32.5813 5.53853 32.6673 15.1577 32.6959 19.9529L32.7675 39.1698C32.7675 39.377 32.7031 39.57 32.6028 39.7272L1.6832 85.9504L1.69752 84.9571L9.78375 97.7421L9.03887 97.3347C28.4702 97.3848 67.5619 97.4134 86.9932 97.3062L86.2197 97.7278L94.2988 84.9356L94.3131 85.9719L63.372 39.7629C63.2502 39.5842 63.1929 39.377 63.1929 39.1769C63.1786 26.7635 63.2287 13.2281 63.4651 0.850452C63.4508 0.400226 63.8375 0.0286099 64.2888 0.0643422L68.3426 0.3502C69.2164 0.435958 69.1663 1.72947 68.2782 1.72947L64.21 1.63656L65.0336 0.850452C65.2342 10.0622 65.27 20.3245 65.313 29.5935V39.1769L65.1339 38.5909L95.8959 84.9142C96.1108 85.2358 96.1036 85.6432 95.9103 85.9504L87.7596 98.6997C87.5877 98.9713 87.2869 99.1214 86.9861 99.1214L48.0089 99.0213L9.03171 99.0999C8.71657 99.0999 8.43724 98.9356 8.27967 98.6926L0.143306 85.929C-0.0572381 85.6146 -0.0357513 85.2215 0.157631 84.9356L30.9268 38.6195L30.7621 39.1769C30.8265 28.3143 30.8337 11.4844 31.0271 0.743255L31.8293 1.47934L28.3197 1.72947C27.4459 1.80093 27.2955 0.457397 28.198 0.357347V0.3502Z'
          }
          fill={'#181716'}
        />
        <path
          d={
            'M57.7997 16.9448C57.8713 25.0632 57.9645 33.1816 57.9931 41.2999L57.8427 40.8068C62.9494 48.1319 67.9917 55.5071 72.9838 62.9108L87.9888 85.1077C88.1965 85.415 88.1965 85.8081 88.0174 86.1011L83.8848 92.8902C83.7129 93.1689 83.4192 93.3261 83.1112 93.3261L47.7224 93.2332L12.3335 93.3619C11.9897 93.3619 11.6961 93.1832 11.5313 92.9116L7.39154 86.1225C7.191 85.7866 7.21249 85.3793 7.42019 85.0791C14.074 75.167 23.213 61.653 29.9169 51.7766C32.4595 48.1033 34.9592 44.4015 37.5376 40.7568L37.3729 41.2928L37.4731 29.1152L37.6379 16.9377C37.6594 16.1015 38.9772 15.9943 39.0202 16.9377C39.1205 23.0193 39.2494 35.2111 39.2924 41.2928C39.2924 41.4929 39.2351 41.6787 39.1276 41.8288C36.6925 45.5735 34.1713 49.2539 31.6932 52.9701C27.9473 58.4943 20.3624 69.5999 16.6022 75.1098L9.02454 86.1582L9.05319 85.1148L13.1429 91.9326L12.3407 91.4823C29.9814 91.5824 65.4849 91.6253 83.1184 91.5181L82.3449 91.954L86.4417 85.1434L86.4704 86.1368L71.3651 64.0042C68.844 60.3166 66.3228 56.6291 63.8447 52.9201C61.3451 49.2182 58.8597 45.5092 56.3959 41.7859C56.2956 41.6358 56.2455 41.4571 56.2455 41.2928C56.2742 33.1744 56.3673 25.056 56.4389 16.9377C56.4389 16.1087 57.7782 15.9729 57.8212 16.9377L57.7997 16.9448Z'
          }
          fill={'#181716'}
        />
        <path
          d={
            'M32.1183 72.0882L29.5221 73.4899L28.4836 76.9942L31.599 78.3959L33.676 76.9942L34.7144 74.8916L32.1183 72.0882Z'
          }
          fill={'white'}
          stroke={'black'}
          strokeWidth={'0.901103'}
        />
        <path
          d={
            'M65.0526 79.297L62.4564 80.6987L61.418 84.203L64.5334 85.6047L66.6103 84.203L67.6488 82.1004L65.0526 79.297Z'
          }
          fill={'white'}
          stroke={'black'}
          strokeWidth={'0.901103'}
        />
        <path
          d={
            'M58.0798 63.0773L54.7419 64.8795L53.4067 69.385L57.4123 71.1872L60.0826 69.385L61.4178 66.6817L58.0798 63.0773Z'
          }
          fill={'white'}
          stroke={'black'}
          strokeWidth={'0.901103'}
        />
      </g>
      <defs>
        <clipPath id={'clip0_8650_5163'}>
          <rect fill={'white'} height={'99.1213'} width={'96.0535'} />
        </clipPath>
      </defs>
    </svg>
  )
}
